/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AiQueryApi } from './services/ai-query-api';
import { AlertsApi } from './services/alerts-api';
import { AnalyticsApi } from './services/analytics-api';
import { AuditApi } from './services/audit-api';
import { AuthApi } from './services/auth-api';
import { BillingPlansApi } from './services/billing-plans-api';
import { BillingProviderWebhookApi } from './services/billing-provider-webhook-api';
import { CommentsApi } from './services/comments-api';
import { DashboardFavoritesApi } from './services/dashboard-favorites-api';
import { DashboardsApi } from './services/dashboards-api';
import { DataSourcesApi } from './services/data-sources-api';
import { DataSourceTypesApi } from './services/data-source-types-api';
import { EmbedsApi } from './services/embeds-api';
import { ExportsApi } from './services/exports-api';
import { ExternalAuthApi } from './services/external-auth-api';
import { ExternalFilesApi } from './services/external-files-api';
import { LocalizationApi } from './services/localization-api';
import { OnboardingApi } from './services/onboarding-api';
import { OrganizationMembersApi } from './services/organization-members-api';
import { OrganizationsApi } from './services/organizations-api';
import { QueriesApi } from './services/queries-api';
import { QueryExecutionApi } from './services/query-execution-api';
import { ReportSchedulesApi } from './services/report-schedules-api';
import { SearchApi } from './services/search-api';
import { SharingApi } from './services/sharing-api';
import { SubscriptionApi } from './services/subscription-api';
import { UsersApi } from './services/users-api';
import { WeatherForecastApi } from './services/weather-forecast-api';
import { WebhookMonitoringApi } from './services/webhook-monitoring-api';
import { WebhooksApi } from './services/webhooks-api';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AiQueryApi,
    AlertsApi,
    AnalyticsApi,
    AuditApi,
    AuthApi,
    BillingPlansApi,
    BillingProviderWebhookApi,
    CommentsApi,
    DashboardFavoritesApi,
    DashboardsApi,
    DataSourcesApi,
    DataSourceTypesApi,
    EmbedsApi,
    ExportsApi,
    ExternalAuthApi,
    ExternalFilesApi,
    LocalizationApi,
    OnboardingApi,
    OrganizationMembersApi,
    OrganizationsApi,
    QueriesApi,
    QueryExecutionApi,
    ReportSchedulesApi,
    SearchApi,
    SharingApi,
    SubscriptionApi,
    UsersApi,
    WeatherForecastApi,
    WebhookMonitoringApi,
    WebhooksApi,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
